export const ORGANIZER_VIEWS = [
  { key: "needs_grading", label: "Needs Grading", hint: "Submitted work waiting for a grade" },
  { key: "this_week", label: "This Week", hint: "Due Monday–Friday of the chosen week, plus overdue unfinished work" },
  { key: "in_progress", label: "In Progress", hint: "Drafts and returned work that is not submitted yet" },
  { key: "not_started", label: "Not Started", hint: "Assigned work with no saved student work" },
  { key: "graded", label: "Graded", hint: "Work with a saved grade" },
  { key: "archived", label: "Archived", hint: "Assignments you archived — still visible to the student" },
  { key: "all", label: "All Assignments", hint: "Searchable full history" },
];

export const STATUS_OPTIONS = [
  { value: "", label: "Any status" },
  { value: "not_started", label: "Not started" },
  { value: "draft", label: "In progress (draft)" },
  { value: "returned", label: "Returned for changes" },
  { value: "submitted", label: "Needs grading" },
  { value: "graded", label: "Graded" },
  { value: "overdue", label: "Overdue & unfinished" },
];

export const SORT_OPTIONS = [
  { value: "due_date", label: "Due date" },
  { value: "submitted_at", label: "Submission date" },
  { value: "title", label: "Title" },
  { value: "graded_at", label: "Graded date" },
];

export const DEFAULT_SETTINGS = {
  view: "needs_grading", student_id: "", q: "", subject: "", status: "",
  due_from: "", due_to: "", sort: "", order: "", include_archived: false,
};

export const localToday = () => new Date().toLocaleDateString("en-CA");

export const formatDay = (value) => {
  if (!value) return "no due date";
  const [y, m, d] = value.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
};

export const formatStamp = (value) => value ? new Date(value).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";

export const loadSettings = (key) => {
  try { return { ...DEFAULT_SETTINGS, ...JSON.parse(localStorage.getItem(key) || "{}") }; }
  catch { return { ...DEFAULT_SETTINGS }; }
};
